import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { PersonDetail } from '@lsq-frontend/remote-services/enterprise/dashboard-services';
import { DateFormat } from '@lsq-frontend/common-ui';
import { Icons, ResponsiveService } from '@lsq-frontend/common-ui';
import { LsqListSource } from '@lsq-frontend/angular-shared/api-service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'documents',
    template: `
        <div class="section-header" [style.marginTop]="'5rem'">
            <h3 i18n>
                Documents
            </h3>
        </div>
        <div>
            <lsq-data-table [dataSource]="dataSource" *ngIf="!(responsiveService.smBelow | async)">
                <lsq-column
                    [column]="{
                        header: documentNameHeader,
                        key: 'documentName',
                        width: '60%',
                        sortable: false
                    }"
                >
                </lsq-column>
                <lsq-date-column
                    [column]="{
                        header: dateAcceptedHeader,
                        key: 'acceptedDate',
                        width: '30%',
                        sortable: false
                    }"
                >
                </lsq-date-column>
                <lsq-column
                    [column]="{
                        header: actionsHeader,
                        key: 'link',
                        width: '10%',
                        sortable: false
                    }"
                >
                    <ng-template [custom-cell] let-row="row">
                        <a [href]="row.link" target="_blank">
                            <lsq-icon
                                [type]="externalLinkIcon"
                                [height]="20"
                                [width]="20"
                            ></lsq-icon>
                        </a>
                    </ng-template>
                </lsq-column>
            </lsq-data-table>

            <lsq-data-table-mobile
                *ngIf="responsiveService.smBelow | async"
                [dataSource]="dataSource"
                [cardsAreExpandable]="false"
            >
                <ng-template #mobileCardHeader let-row="row">
                    <a [href]="row.link" target="_blank" class="no-styling">
                        <div class="mtc-header-content">
                            <div class="mtc-header-title">{{ row.documentName }}</div>
                            <div class="mtc-header-sub-title">
                                {{ dateAcceptedHeader }}:
                                {{ row.acceptedDate | date: dateFormat.LsqShortYear }}
                            </div>
                        </div>
                    </a>
                </ng-template>
            </lsq-data-table-mobile>
        </div>
    `
})
export class DocumentsComponent implements OnChanges {
    @Input() public personDetail: PersonDetail;
    private _personDetailSubject = new BehaviorSubject<PersonDetail>(null);

    public dataSource = new LsqListSource<any>({
        rows$: this._personDetailSubject.pipe(
            map((personDetail) => {
                if (personDetail?.eulaAcceptedDate) {
                    return [
                        {
                            documentName: this._i18n('End-User License Agreement'),
                            acceptedDate: personDetail.eulaAcceptedDate,
                            link: 'https://lsq.com/eula/'
                        }
                    ];
                }
                return [];
            })
        )
    });

    public documentNameHeader = this._i18n('Document Name');
    public dateAcceptedHeader = this._i18n('Date Accepted');
    public actionsHeader = this._i18n('Actions');

    public externalLinkIcon = Icons.FaExternalLink;
    public dateFormat = DateFormat;

    constructor(public responsiveService: ResponsiveService, private _i18n: I18n) {}

    public ngOnChanges(changes: SimpleChanges) {
        this._personDetailSubject.next(changes?.personDetail?.currentValue);
    }
}
